<template>
  <div class="Aboutus">
    <div class="bigImg">
      <div class="top-left">
        <img class="top-img" src="../../static/index/top-app.png" alt="" />
        <div class="top-title">稳健金企 焕发新生</div>
        <div class="top-titles">香港黄金交易所AA类行员</div>
        <img
          class="top-imgs"
          @click="toLoad"
          src="../../static/index/top-download.png"
          alt=""
        />
        <div class="top-flex">
          <div class="top-bottoms">
            <img src="../../static/index/smartphone-device.png" alt="" />
            <div>
              <span>支持多平台</span>
              <span>双端互通</span>
            </div>
          </div>
          <div class="top-line"></div>
          <div class="top-bottoms">
            <img src="../../static/index/verified-user.png" alt="" />
            <div>
              <span>简单</span>
              <span>易用</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="iconBox">
     <div class="left">
      <img src="../../static/aboutus/cup.png" alt="">
     </div>
     <div class="right">
        <div class="tit">香港黄金交易所<span>AA类</span>行员</div>
        <div class="tits">金融牌照编号 ：NO.081</div>
        <div class="cont">
          <span>RED LION CAPITAL，简称RLC，</span>是我们为大众投资者倾心打造的独立品牌，旨在向客户提供超低点差和超低利率的交易产品，让客户的投资物超所值，没有后顾之忧。公司依照全球最受欢迎的交易方式，专注为客户提供安全、稳定、高效的一站式交易服务。自品牌成立以来，红狮集团一直秉承“客户至上，诚信为本”的经营理念，致力于高科技智能化交易平台的建设，专业、专注、规范操作让红狮集团赢得了客户的高度信赖，同时也得到了业界的广泛关注和大力支持。
        </div>
        <div class="cont">
          <span>红狮集团</span>还为客户提供全面的资讯服务，独到的行情走势分析，重要经济播报和专业在线咨询等，全方位满足投资者的需求。公司采用全球领先的MT4交易平台，为投资者提供一站式现货投资服务。公司交易平台的稳定性更是备受市场赞誉，支持一秒平仓、EA智能交易，这些都对平台的稳定性有着高度的技术要求，而我们致力于超越行业技术标准。
展望未来，红狮集团全体同仁将继续实践客户至上的经营理念，努力开拓创新，不断完善和提升产品服务，以帮助投资者实现梦想，共创美好生活。
        </div>
     </div>
    </div>
    <div class="contentBox">
      <img src="../../static/aboutus/card1.png" alt="">
      <img src="../../static/aboutus/card2.png" alt="">
      <img src="../../static/aboutus/card3.png" alt="">
      <img src="../../static/aboutus/card4.png" alt="">
    </div>
  </div>
</template>
<script>
import eventBusMitter from '../../utils/eventbus'

  export default {
    name: 'Aboutus',
    metaInfo: {  
      title: '关于红狮金业,现货黄金开户平台,伦敦金,伦敦银,安全持牌黄金交易平台',  
      meta: [  
        { name: 'keywords', content: '红狮金业,红狮启富,黄金交易平台,贵金属交易,贵金属投资,贵金属平台,现货黄金开户,正规靠谱外汇交易,正规网上交易平台' },  
        { name: 'description', content: '红狮金业是专业值得信赖的国际投资交易平台,专注于为客户提供24小时全球金融产品在线交易,包括现货黄金、现货白银、贵金属等产品的开户、投资交易服务。' }  
      ]  
    },  
    data() {
      return{
        screenWidth:null
      }
    },
    created(){
      console.log(Number(sessionStorage.getItem('gold')));
      eventBusMitter.emit('eventtab', { key: false })

      // 传参控制显示顶部和底部
      this.$emit('controlShow', false);
    },
    methods:{
      toLoad(){
            eventBusMitter.emit('eventNas', {key:4})


        this.$router.push({
              name: "Appdownload",
              query: {
                showTop:true,
                showTops:true
              }
            });
      }
    },
    mounted(){
      //获取屏幕尺寸
    this.screenWidth = document.body.clientWidth;
    window.onresize = () => {
      //屏幕尺寸变化
      return (() => {
        this.screenWidth = document.body.clientWidth;
        console.log('屏幕宽度',this.screenWidth)
      })()
    };
    },
    watch: {
    screenWidth(n) {
      console.log('屏幕发生了变化888',n)
      if (n <= 500) {
        this.$router.push({
          name: "wapAboutUs",
        });
      }
    },
    
  },
    
  }
</script>

<style lang="less" scoped>
  .Aboutus{
    width: 100%;
    margin: 0 auto;
    .bigImg{
      width: 100%;
      height: 810px;
      background: url('../../static/aboutus/topbg.png') no-repeat;
      background-size: cover;
      padding-top: 163px;
      box-sizing: border-box;
      .top-left {
      display: flex;
      flex-direction: column;
      width: 1320px;
      margin: 0 auto;
      // align-items: center;
      .top-title {
        color: #fff;
        font-size: 80px;
        font-weight: 700;
        line-height: 106px;
        margin: 34px 0 26px 0;
      }
      .top-img {
        width: 139px;
        height: 38px;
      }
      .top-imgs {
        margin: 66px 0 110px 0;
        width: 198px;
        height: 56px;
        cursor: pointer;
      }
      .top-titles {
        color: #fff;
        font-size: 26px;

        line-height: 34px;
      }
    }
    .top-flex {
      display: flex;
      align-items: center;
    }
    .top-line {
      width: 1px;
      height: 60px;
      margin: 0 32px;
      background: #fff;
    }
    .top-bottoms {
      display: flex;
      align-items: center;
      div {
        display: flex;
        // align-items: center;
        flex-direction: column;
        color: #fff;
        font-size: 16px;
        line-height: 26px;
        margin-left: 12px;
      }
    }
    }
    .iconBox{
      width: 1328px;
      margin: 0 auto;
      display: flex;
      justify-content: space-around;
      align-items: center;
      box-sizing: border-box;
      padding: 80px 20px;
      .left{
      width: 490px;
height: 583px;
margin-right: 60px;


      }
      .right{
        .tit{
          span{
            color: #FA2314;
          }
        
          font-size: 46px;
          line-height: 61px;
          color: #0F0F11;
            font-weight: 700;

;
        }
        .tits{
          margin-top: 18px;
          font-size: 18px;
          line-height: 24px;
          color: #0F0F11;
          margin: 18px 0 10px 0;

        }
        .cont{
          margin-top: 36px;
          span{
            color: #FA2314;
            font-weight: 700;
          }
          
          font-size: 18px;
          line-height: 30px;
          color:  #93939F;
;
        }
      }
    }
    .contentBox{
      width: 100%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      padding-top: 20px;
      flex-wrap: wrap;
      img{
       width: 636px;
       height: 336px;
       margin-bottom: 48px;
      }
      
    }
    .contentBox img:nth-child(1){
        margin: 0 48px 48px 0;
      }
      .contentBox img:nth-child(4){
        margin:  0px 0 48px 48px ;
      }
  }
  @media screen and (min-width: 1264px) and (max-width: 1724px) {
   .Aboutus{
    .bigImg{
      .top-left{
        width: 1100px;
        margin:  0 0 0 150px;
        .top-title{
          font-size: 60px;
        }
      }

    }
    .iconBox{
      width: 1000px;
      .right{
        .tit{
          font-size: 36px;
        }
      }
    }
    .contentBox{
      img{
        width: 407px;
        height: 198px;
      }
    }
   }
  }
</style>